<template>
  <div>
    <vendor-dashboard />
  </div>
</template>
<script>
import VendorDashboard from '../views/Vendor-Dashboard.vue';

export default {
  components: {
    VendorDashboard
  },
  data() {
    return {
      authenticated: '',
      headerTag: {
        'animated fadeIn': false,
        hidden: true,
      },
      loggedInUser: {}
    };
  },
  props: ['session'],
  beforeRouteEnter (to, from, next) {
    const userContext = JSON.parse(localStorage.getItem('loginToken'));

    if (!userContext) {
      window.location.href = '/login';
    }

    next();
  },
  beforeMount() {
    this.tokenizer();
    this.getCurrentUser();
  },
  mounted() {
    this.tokenizer();
  },
  methods: {
    tokenizer() {
      const userContext = JSON.parse(localStorage.getItem('loginToken'));
      if (!userContext) {
        this.loggedInUser = {};
        window.location.href = './login';
        // window.location.href = './dashboard';
      }
    },
    getCurrentUser() {
      const userContext = JSON.parse(localStorage.getItem('loginToken'));
      if (!userContext) {
        this.loggedInUser = {};
      } else {
        this.loggedInUser = userContext.user_digest;

        // if (this.loggedInUser.role_code == 'JPNV') {
        //   window.location.href = './vendor-dashboard';
        // }
      }
    },
  },
};
</script>
<style scoped>

</style>
